import { Image, Space } from "antd";
import { getOrderStatusColor } from "../utils/Common";

export const tableColsOrderList = [
  {
    title: "SL",
    dataIndex: "sl",
    key: "sl",
  },
  {
    title: "Order No.",
    dataIndex: "orderNumber",
    key: "orderNumber",
  },
  {
    title: "Restaurant",
    dataIndex: "restaurantName",
    key: "restaurantName",
  },
  {
    title: "Customer",
    dataIndex: "customer",
    key: "customer",
  },
  {
    title: "Order Type", // with Table No
    dataIndex: "orderType",
    key: "orderType",
  },
  {
    title: "Order Time", // with Table No
    dataIndex: "orderTime",
    key: "orderTime",
  },
  {
    title: "Payment Type", // with Table No
    dataIndex: "paymentType",
    key: "paymentType",
  },
  {
    title: "Amount", // with Table No
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Payment Status", // with Table No
    dataIndex: "paymentStatus",
    key: "paymentStatus",
    render: (text) => (
      <span
        className={`font-semibold ${
          text === "Paid" ? "text-green" : "text-red-600"
        }`}
      >
        {text}
      </span>
    ),
  },
  {
    title: "Order Status", // with Table No
    dataIndex: "orderStatus",
    key: "orderStatus",
    render: (text) => (
      <span
        className="font-semibold"
        style={{ color: getOrderStatusColor(text.toLowerCase()) }}
      >
        {text}
      </span>
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <a
          href={`/sales/orders/${record.orderId}/details`}
          title="View Details"
        >
          <Image
            height={38}
            width={38}
            src="/images/icons/view.svg"
            alt="view"
            preview={false}
          />
        </a>
      </Space>
    ),
  },
];
